import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ActionButton } from "@talentbait/shared-components";
import {
  FormContainer,
  FormGroup,
  Input,
  Label,
  ButtonGroup,
  ReadOnlyInput,
  ModalContent
} from "./Modals.styled";

const CreateDomainSkillForm = ({
  onSubmit,
  onCancel,
  jobCategoryId = "",
  categoryId = "",
  category = ""
}) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
    category,
    jobCategoryId,
    categoryId,
    isTest: false
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Only allow changing the name field
    if (name === "name") {
      setFormData((prev) => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.category || !formData.jobCategoryId) {
      alert(t("Please fill in all required fields"));
      return;
    }

    onSubmit(formData);
  };

  const formDisabled = [formData.name, formData.category].some((field) => !field);

  return (
    <ModalContent>
      <h1>{t("Create New Domain Skill")}</h1>
      <FormContainer onSubmit={handleSubmit}>
        <FormGroup>
          <Label>{t("Skill Name")} *</Label>
          <Input
            type="text"
            value={formData.name}
            onChange={handleInputChange}
            name="name"
            placeholder={t("Enter skill name")}
            required
          />
        </FormGroup>

        <FormGroup>
          <Label>{t("Category")} *</Label>
          <ReadOnlyInput
            type="text"
            value={formData.category}
            name="category"
            placeholder={t("Category is automatically set")}
            readOnly
            disabled
          />
        </FormGroup>

        <FormGroup direction="row">
          <FormGroup flex={1}>
            <Label>{t("Job Category ID")} *</Label>
            <ReadOnlyInput
              type="text"
              value={formData.jobCategoryId}
              name="jobCategoryId"
              placeholder={t("Job category ID is automatically set")}
              readOnly
              disabled
            />
          </FormGroup>

          <FormGroup flex={1}>
            <Label>{t("Category ID")} *</Label>
            <ReadOnlyInput
              type="text"
              value={formData.categoryId}
              name="categoryId"
              placeholder={t("Category ID is automatically set")}
              readOnly
              disabled
            />
          </FormGroup>
        </FormGroup>

        <ButtonGroup>
          <ActionButton
            type="submit"
            variant="create"
            text={t("Create Domain Skill")}
            disabled={formDisabled}
          />
          <ActionButton variant="secondary" onClick={onCancel} text={t("Cancel")} />
        </ButtonGroup>
      </FormContainer>
    </ModalContent>
  );
};

export default CreateDomainSkillForm;
